import { SimpleVerticalBarChart } from "../Global/SimpleVerticalBarChart"
import { SimpleHorizontalBarChart } from "../Global/SimpleHorizontalBarChart"

export const SimpleBarWidget = (props) => {
    return(
        <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center', width: 'inherit', height: props.height}}>
            {props.layout === 'vertical' ?
            <SimpleVerticalBarChart data={props.data} layout={props.layout} name={props.name}/>
            :
            <SimpleHorizontalBarChart data={props.data} layout={props.layout} name={props.name}/>
            }
            <p style={{fontWeight: 'bold', color: '#659767', margin: '5px 0 0 0', fontSize: 'small'}}>{props.label}</p>
        </div>
    )
}